import { baseOTSupervisory } from '../validations/ot-supervisory/v1';
const shape = baseOTSupervisory.shape;
export const evaluationFields = [
    { key: 'onSiteVisit', field: shape.onSiteVisit },
    { key: 'maintainsOpenCommunication', field: shape.maintainsOpenCommunication },
    { key: 'arrivesAsScheduled', field: shape.arrivesAsScheduled },
    { key: 'followsPlanOfCare', field: shape.followsPlanOfCare },
    { key: 'goalProgress', field: shape.goalProgress },
    { key: 'demonstratesCompetency', field: shape.demonstratesCompetency },
    { key: 'informsSupervisor', field: shape.informsSupervisor },
    { key: 'compliesWithInfectionControl', field: shape.compliesWithInfectionControl },
    { key: 'honorsClientRights', field: shape.honorsClientRights },
    { key: 'changesMadeToPlanOfCare', field: shape.changesMadeToPlanOfCare },
    { key: 'deficiencyIdentified', field: shape.deficiencyIdentified },
];
